var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bm-overlay',{ref:"customOverlay",class:['sample', _vm.iconType],attrs:{"pane":"labelPane"},on:{"draw":_vm.draw}})
}
var staticRenderFns = []

export { render, staticRenderFns }